import { useEffect } from 'react';
import HomeSection from './HomeSection';
import AboutSection from './AboutSection';
import CourseSection from './CourseSection';
import RegisterSection from './RegisterSection';
import BatchSection from './BatchSection';
import TestimonialSection from './TestimonialSection';
import FooterSection from './FooterSection';
import '../../../assets/css/bootstrap.min.css';
import '../../../assets/css/stylefdf2.css';
import '../../../assets/css/owl.carousel.css';
import '../../../assets/css/owl.theme.css';
import '../../../assets/css/hover-min.css';
import '../../../assets/css/flag-icon.min.css';
import '../../../assets/css/colors/color-1.css';
import '../../../assets/css/nile-slider.css';
import '../../../assets/css/elegant_icon.css';
import '../../../assets/css/font-awesome.min.css';

export default function HomePage() {
  useEffect(() => {
    // CustomJs();
  });
  return (
    <div className="background-white">
      <HomeSection />
      <AboutSection />
      <CourseSection />
      <RegisterSection />
      <BatchSection />
      <TestimonialSection />
      <FooterSection />
    </div>
  );
}
